const ROUTE_BASE = '/account/clientmgr';
const ROUTE_BASE_APPS = `${ROUTE_BASE}/apps`;
export { ROUTE_BASE, ROUTE_BASE_APPS };
